import cx from 'classnames';
import { LoadingIndicator } from '@THC/components/LoadingIndicator';
import { MDText } from 'i18n-react';

import LocalTexts from '../../AiCompanion.texts';

import styles from './Placeholder.module.scss';

interface PlaceholderProps {
	isBusy: boolean;
	isRandom: boolean;
	isVisible: boolean;
}

const LocalT = new MDText(LocalTexts);

export const Placeholder = ({ isBusy, isRandom, isVisible }: PlaceholderProps) => {
	if (isBusy) {
		return (
			<div className={styles.loader}>
				<LoadingIndicator data-spinner-busy showText text={LocalT.translate('loading') as string} variant="spinner" />
			</div>
		);
	}

	if (isVisible) {
		return (
			<div className={cx(styles.placeholder, isRandom && styles.static)}>
				{isRandom ? LocalT.translate('inputPlaceholder') : LocalT.translate('placeholder0')}
			</div>
		);
	}

	return null;
};
